import Footer from "../ones/Footer";
import OneService from "../ones/OneService";

export default function ServiceDetail(props) {
  const { serviceSlug } = props;

  return (
    <>
      <OneService serviceSlug={serviceSlug} />
      <Footer />
    </>
  );
}

